<script setup lang="ts"></script>

<template>
  <IndexHeaderContainer>
    <IndexHeaderContent />
  </IndexHeaderContainer>
</template>
